import React from 'react';
import cn from 'classnames';
import {useTranslation} from 'react-i18next';
import ReactSignatureCanvas from 'react-signature-canvas';

import styles from './SignatureCanvas.module.sass';

const CANVAS_PROPS = {
  width: 319,
  height: 182,
};
const SIGNATURE_PROPS = {
  penColor: '#161643',
  minWidth: 1.5,
  maxWidth: 1.5,
  dotSize: 1,
};

type SignatureCanvasProps = {
  onClear?: () => void;
  onEnable?: () => void;
  hasSignature?: boolean;
  onEnd?: () => void;
  onStart?: () => void;
  className?: string;
  enabled?: boolean;
};

const defaultProps: SignatureCanvasProps = {
  onEnd: () => {},
  onEnable: () => {},
  onStart: () => {},
  onClear: () => {},
  hasSignature: false,
  className: '',
  enabled: false,
};

const SignatureCanvas = React.forwardRef<ReactSignatureCanvas, SignatureCanvasProps>(
  ({onClear, hasSignature, onEnd, onStart, onEnable, className, enabled}, ref) => {
    const {t} = useTranslation();

    const enableSignature = () => {
      if (onEnable) {
        onEnable();
      }
    };

    return (
      <div className={cn(styles.signWrapper, className)}>
        {!enabled && (
          <div
            className={styles.signPlaceholder}
            data-testid="signature-placeholder"
            onClick={enableSignature}
          >
            <div className={styles.signPlaceholderText}>{t('click_here_to_sign')}</div>
          </div>
        )}
        <div hidden={!enabled} className={styles.signCanvas}>
          <ReactSignatureCanvas
            ref={ref}
            data-testid="canvas"
            {...SIGNATURE_PROPS}
            canvasProps={CANVAS_PROPS}
            onEnd={onEnd}
          />
        </div>
        <div>
          <button
            type="button"
            className={cn(styles.repeatButton, {
              [styles.visible]: enabled && hasSignature,
            })}
            onClick={onClear}
          >
            {t('repeat_signature')}
          </button>
        </div>
      </div>
    );
  },
);

SignatureCanvas.defaultProps = defaultProps;
export {SignatureCanvas};
